import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useStoryTags from '../../../hooks/useStoryTags';
import TagTypes from '../../../constants/TagTypes';
import useTags from '../../../hooks/useTags';
import TextContentSection from '../../../components_profiles/TextContentSection';

Ages.propTypes = {
  story: PropTypes.object.isRequired
};

export default function Ages(props) {
  const { story } = props;

  const ages = useTags(TagTypes.Age);
  const storyAges = useStoryTags(story, TagTypes.Age);

  if (storyAges.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <TextContentSection title="Age groups">
      <ul className="list-disc ml-6">
        {ages.data.map(function(age) {
          const storyAge = _.find(storyAges.data, function(storyAge) {
            return storyAge._tag.id === age.id;
          });

          if (!storyAge) {
            return null;
          }

          return (
            <li key={age.id || age.cid}>
              {age.data.name}
            </li>
          );
        })}
      </ul>
    </TextContentSection>
  );
};
